import { Component } from '@angular/core';

/** Conteúdo do popover do card quando o usuário não tem nenhuma role do módulo. */
@Component({
    selector: 'app-acesso-negado',
    imports: [],
    templateUrl: './acesso-negado.html'
})
export class AcessoNegado {}
